import React from 'react';

import { AccountSection } from '../components/header/account-section';
import { ProfileSection } from '../components/header/profile-section';
import { useUserStates } from 'app/shared/hooks/restricted/useUserStates';

export const UserProfileSection = () => {
  const { accountOptions, selectedAccount, userProfile } = useUserStates();
  return (
    <>
      <AccountSection email={userProfile?.email} accountOptions={accountOptions} selectedAccount={selectedAccount} />
      <ProfileSection />
    </>
  );
};
